import React from 'react';

import { Snippet as ArticleInlineSnippetProps } from 'lib/sanity/types';
import BlockSerializer, { inlineSerializer } from 'lib/sanity/ui/BlockSerializer';

const ArticleInlineSnippet = ({ snippet }: { snippet: ArticleInlineSnippetProps | undefined }) => {
  if (!snippet?.content?.length) {
    return null;
  }

  const inlineSnippetSerializer = {
    ...inlineSerializer,
    container: ({ children }: { children: JSX.Element[] }) => children,
    block: ({ children, node }: { children: JSX.Element[]; node: { _type: string } }) => {
      const serializer = inlineSerializer.types[node._type];
      if (serializer) return serializer({ node: node });
      return children;
    },
  };

  return <BlockSerializer blocks={snippet.content} serializers={inlineSnippetSerializer} />;
};

export default ArticleInlineSnippet;
